<template>
  <div class="view-sale-chart">
    <div class="row align-items-center mb-5">
      <div class="col-lg-4">
        <form-group
          v-if="isProductSelect && !isPaymentTypeSelect"
          v-model="filters.product_id"
          id="product-select"
          placeholder="Selecione o produto"
          select
          slim
          :options="[
            { id: 'all', name: 'Todos os produtos' },
            ...products.map(({ id, name }) => ({ id, name }))
          ]"
        />
        <form-group
          v-if="isPaymentTypeSelect && !isProductSelect"
          select
          slim
          v-model="filters.payment_method_id"
          id="pay-method-select"
          placeholder="Método de pagamento"
          :options="[
            { id: 'all', name: 'Todos os métodos' },
            ...paymentMethods
          ]"
        />
      </div>
      <div class="col-lg-3 mb-3 mb-lg-0">
        <form-group
          v-model="filters.currencyType"
          id="currency-select"
          placeholder="Moeda do produto"
          select
          slim
          :options="currencies"
        />
      </div>
      <div class="col-lg-5">
        <switch-date-picker
          radius
          slim
          v-model="dates"
          @input="changeDates"
          :options="[
            { title: 'Semana', rangeLength: 7 },
            { title: 'Mês', rangeLength: 30 },
            { title: 'Ano', rangeLength: 365 },
            { title: 'Período', rangeLength: null } //custom range
          ]"
        />
      </div>
    </div>
    <div class="chart-card overview-card">
      <div v-if="loading" class="text-center">
        <b-spinner variant="primary" />
      </div>
      <line-chart v-else :data="revenuesByDay" />
    </div>
  </div>
</template>

<script>
import SwitchDatePicker from "@/components/SwitchDatePicker.vue";
import ChartsMixin from "@/mixins/charts.js";
import SaleMixin from "@/mixins/sale.js";
import LineChart from "./baseChart/Line.js";

export default {
  mixins: [SaleMixin, ChartsMixin],
  components: {
    LineChart,
    SwitchDatePicker
  },
  props: {
    externalLoading: {
      type: Boolean,
      default: false
    },
    chartColor: {
      type: String,
      default: "#9155EC"
    },
    isPaymentTypeSelect: {
      type: Boolean,
      default: false
    },
    isProductSelect: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false,
      test: "",
      dates: []
    };
  },
  mounted() {
    this.gradientColor = this.chartColor;
    this.$store.dispatch("product/get", { limit: 1000 }).then();
    this.$store.dispatch("product/getPaymentMethods").then();
    this.$store.dispatch("product/getCurrency").then();
    this.filters.product_id = this.$route.params.id;
    this.refresh();
  },
  watch: {
    chartColor(val) {
      this.gradientColor = val; //mixin variable
    },
    externalLoading(val) {
      this.loading = val;
    },
    "filters.product_id"(product_id) {
      this.$emit("change-product", product_id);
      this.refresh();
    },
    "filters.payment_method_id"(product_id) {
      this.$emit("change-pay-method", product_id);
    },
    "filters.currencyType"(currency_id) {
      this.$emit("change-currency", currency_id);
    },
    dates(val) {
      if (val && val.length === 2) {
        this.filters["paid_at_after"] = val[0];
        this.filters["paid_at_before"] = val[1];
        this.$emit("change-dates", val);
      }
    }
  },
  methods: {
    changeDates(val) {
      if (val && val.length === 2) {
        this.$emit("change-dates", val);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.view-sale-chart {
  .chart-card {
    width: 100%;
    flex-grow: 1;
    padding: 20px;

    ::v-deepcanvas {
      max-height: 230px;
    }
  }
}
</style>
